import { Container } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cookieHtml } from "../../api/modules/b2droppie.class";
import { toggleLoader } from "../../redux/slices/loaderSlice";
import BackdropLoader from "../../components/BackdropLoader/BackdropLoader";

const Cookie = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState();
  const isLoading = useSelector((state) => state?.loader?.isLoading);

  useEffect(() => {
    try {
      dispatch(toggleLoader({ isLoading: true }));
      cookieHtml()
        .then((response) => {
          setValue(response?.data?.data);

          dispatch(toggleLoader({ isLoading: false }));
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log("Failed", e);
    }
  }, []);

  return isLoading ? (
    <BackdropLoader show={isLoading} />
  ) : (
    <Container className="px-5 py-5">
      <h1 className="text-center p-3">Cookie Policy</h1>
      {value
        ? value?.map((item, index) => (
            <div dangerouslySetInnerHTML={{ __html: item?.description }} />
          ))
        : null}
    </Container>
  );
};

export default Cookie;
